import { render, staticRenderFns } from "./EntityCard.vue?vue&type=template&id=4d1da190&scoped=true&"
import script from "./EntityCard.vue?vue&type=script&lang=js&"
export * from "./EntityCard.vue?vue&type=script&lang=js&"
import style0 from "./EntityCard.vue?vue&type=style&index=0&id=4d1da190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1da190",
  null
  
)

export default component.exports